import React from "react";
import { useFormContext,useController } from "react-hook-form";
import { JSONTree } from "react-json-tree";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable'

const InputSelectField = ({ source, required = true,labelRequired = true, disable = false, creatable = false, options, label, ariaLabel = undefined, multiple = false ,onChangeCallback=(selectedOption)=>{}, labelAsteriskClass = "red", labelClass = "form-label" , requiredClass = {} , fontsize = "14px", stopAutoFocus = false,isClearable=true, dataTestId = undefined }) => {
  const { control, getValues } = useFormContext();
  const { field, fieldState } = useController({
    name: source,
    control,
    defaultValue: multiple ? [] : "",
  });
  const isDisable = disable;
  const selectRef = React.useRef(null);
  const normalizedId = React.useMemo(() => {
    return (source || "select").toString().replace(/[^a-zA-Z0-9_-]/g, "-");
  }, [source]);
  const resolvedTestId = dataTestId || `${normalizedId}-select`;
  const accessibleLabel = ariaLabel || label || normalizedId;
  const selectAccessibilityProps = {
    inputId: normalizedId,
    instanceId: normalizedId,
  };
  const selectWrapperProps = React.useMemo(() => ({ 'data-testid': resolvedTestId }), [resolvedTestId]);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px solid rgba(255, 133, 133, 0.37)",
      backgroundColor: "#FFF8F8",
      fontSize: fontsize
    }),
    menu: base => ({  
      ...base,
      fontSize: fontsize,
      zIndex:requiredClass?.zIndexValue?requiredClass?.zIndexValue:1
    })
  };
  const FontcustomStyles = {
    control: (base, state) => ({
      ...base,
      fontSize: fontsize
    }),
    menu: base => ({  
      ...base,
      fontSize: fontsize,
      zIndex:requiredClass?.zIndexValue?requiredClass?.zIndexValue:1
    })
  };

  //Applying a logic for stop auto focused element if needed to passing a stopAutoFocus props
  React.useEffect(() => {
    if (selectRef.current ) {
      if(stopAutoFocus){
        selectRef.current.blur(); //Remove focus from the element
      }else{
        selectRef.current.focus();
      }
    }
  }, [selectRef]);
  const selectedValue = React.useMemo(() => {
    if (multiple) {
      return Array.isArray(field.value) ? field.value : [];
    }
    if (creatable) {
      if (!field.value) return null;
      if (typeof field.value === "object") return field.value;
      return { value: field.value, label: field.value };
    }
    if (field.value && typeof field.value === "object") return field.value;
    return options?.find(
      (item) => item?.value === field.value || item?.label === field.value
    ) || null;
  }, [field.value, multiple, creatable, options]);
  
  return (
    <>
      {labelRequired && <label
        htmlFor={normalizedId}
        className={`${fieldState.error !== undefined && "text-danger"} ${labelClass}`}
      >
        {label} {required && <span className={labelAsteriskClass}>*</span>}
      </label>}
      {creatable ? <><div {...selectWrapperProps}>
        <CreatableSelect
          isDisabled={isDisable}
          styles={required && !field.value && customStyles}
          className={`${required && !field.value && "is-warning"} ${fieldState.error !== undefined && "is-invalid"
            }`}
          {...selectAccessibilityProps}
          aria-label={accessibleLabel}
          value={selectedValue}
          onChange={(selectedOption) => {
            field.onChange(selectedOption);
            onChangeCallback(selectedOption);
          }}
          options={options}
        />
      </div>
        <div id={source + 'btn'} className="form-text">Please select from the drop-down or type to create other option.</div>
      </>
        : <div {...selectWrapperProps}>
          <Select
            isDisabled={isDisable}
            styles={(required && !field.value) ? customStyles: FontcustomStyles}
            className={`${required && !field.value && "is-warning"} ${fieldState.error !== undefined && "is-invalid"
              }`}
            {...selectAccessibilityProps}
            aria-label={accessibleLabel}
            onChange={(selectedOption)=>{
                field.onChange(selectedOption);
                onChangeCallback(selectedOption);
            }}
            value={selectedValue}
            options={options}
            isMulti={multiple}
            closeMenuOnSelect={!multiple}
            maxMenuHeight={200}
            isClearable={isClearable}
            ref={selectRef}
          />
        </div>
      }

      <div className="invalid-feedback d-block" style={requiredClass}> 
        {fieldState.error !== undefined && fieldState.error?.message}
      </div>
    </>
  );
};

export default InputSelectField;
